
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mot-de-passe-oublie",
      function () {
        return require("private-next-pages/mot-de-passe-oublie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mot-de-passe-oublie"])
      });
    }
  